<h2 mat-dialog-title translate="CALLS.NEW_SPEAKER" class="title"></h2>
<mat-dialog-content class="dialogContent">
  <p translate="CALLS.NEW_SPEAKER_DESCRIPTION" class="description"></p>
  <mat-form-field>
    <mat-label translate="COMMON.NAME"></mat-label>
    <input matInput name="name" [(ngModel)]="speakerName" [matAutocomplete]="auto" cdkFocusInitial />
    <mat-autocomplete #auto="matAutocomplete">
      @for (name of filteredAttendeeNames; track name) {
        <mat-option [value]="name">{{ name }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button mat-button [mat-dialog-close]="speakerName" translate="COMMON.ADD" [disabled]="!speakerName" color="primary"></button>
</mat-dialog-actions>
